import styled from 'styled-components';
import { Button } from '../../../styles';

export const SidebarStyle = styled.div`
    position: absolute;
    left: 3vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9;
`;

export const SidebarButton = styled(Button)`
    position: static;    
    width: 208px;
    padding: 12px 16px;
    height: 36px;
    left: 0px;
    top: 0px;
    background: ${props => props.expanded ? '#E5EBF0' : '#FFFF'};
    border: ${props => props.expanded ? '1px solid #012939' : '1px solid #7F9DB3'};
    border-radius: 20px;
    ${props => props.expanded && `
        font-weight: bold;
    `};
`;

export const SecondarySidebarButton = styled(SidebarButton)`
    background: ${props => props.disabled ? props.theme.darkGrey : props.theme.secondaryDarkBlue};
    color: #fff;
    font-weight: bold;
    border: none;
    margin-top: ${props => props.margin ?? '0'};
    &:hover {
        background: ${props => !props.disabled && props.theme.primaryDarkBlue};
    }
`;

export const DropdownStyle = styled.div`
    text-align: left;
    cursor: pointer;
    font-size: ${props => props.theme.smallFont};
    transition: 0.3s ease;
    ul {
        list-style-type: none;
        padding-inline-start: 15px;
    }
`;

export const RebuttalListItem = styled.li`
    cursor: pointer;
    border-bottom: 1px solid #7F9DB3;
    color: #012939;
    padding: 8px 0;
    margin: 5px;
    ${props => props.selected && 'font-weight: bold'};
    &:hover {
        text-decoration: underline;
    }
`;
